<template>
  <div>
    <vs-row
        class="mt-0 mb-4"
        vs-align="center"
        vs-justify="center"
        vs-type="flex"
        vs-w="12"
    >
      <vs-col
          vs-align="flex-end"
          vs-justify="flex-end"
          vs-type="flex"
          vs-w="12"
      >
        <vs-input
            v-model="filtro.data_emissao"
            class="mx-1 my-0"
            color="dark"
            label="Data de Emissão"
            size="small"
            type="date"
        ></vs-input>
        <vs-input
            v-model="filtro.data_emissao_final"
            class="mx-1 my-0"
            color="dark"
            label="Data de Emissão (Final)"
            size="small"
            type="date"
        ></vs-input>
        <div>
          <label class="m-0 pl-3" style="color: black; font-size: 0.85rem"
          >Empresa</label
          >
          <br/>
          <el-select
              v-model="filtro.id_empresa"
              class="mx-1 mt-2"
              clearable
              filterable
              placeholder="Empresa"
              size="small"
          >
            <el-option
                v-for="empresa in empresas"
                :key="empresa.id"
                :label="empresa.razao_social"
                :value="empresa.id"
            ></el-option>
          </el-select>
        </div>
        <div>
          <label class="m-0 pl-3" style="color: black; font-size: 0.85rem"
          >Tipo Pessoa</label
          >
          <br/>
          <el-select
              v-model="filtro.tipo_pessoa"
              :popper-append-to-body="false"
              class="mx-1 mt-2"
              clearable
              filterable
              size="small"
          >
            <el-option
                v-for="tipo in tipo_pessoa"
                :key="tipo.value"
                :label="tipo.nome"
                :value="tipo.value"
            ></el-option>
          </el-select>
        </div>
        <div>
          <vs-input
              v-model="filtro.busca"
              class="mx-2"
              label="Busca (Cliente ou NF)"
              size="small"
              type="text"
              @keyup.enter="getBoletos()"
          ></vs-input>
        </div>
        <el-button
            class="mx-1"
            plain
            size="small"
            type="primary"
            @click="getBoletos()"
        >FILTRAR
        </el-button
        >
      </vs-col>
    </vs-row>
    <div
        id="tabelaBoletos"
        class="cardTable mb-1 vs-con-loading__container"
        max-items="10"
        pagination
    >
      <div
          v-if="notasBoletos.length == undefined || notasBoletos.length == 0"
          class="mt-1"
      >
        <div class="pt-20 scroll-boleto con-colors">
          <ul class="pt-20">
            <li class="danger-box">
              <h2 class="p-5" style="color: white !important">Nenhum Boleto</h2>
            </li>
          </ul>
        </div>
      </div>
      <div v-else class="mt-1 scroll-boleto">
        <!-- <VuePerfectScrollbar class="scroll-boleto" :settings="settings"> -->
        <vs-table
            id="tableBoletos"
            v-model="selected"
            :data="notasBoletos"
            class="px-2"
            color="success"
            max-items="120"
            maxHeight="65vh"
            multiple
            pagination
            stripe
        >
          <template slot="thead">
            <vs-th id="center" sort-key="id" style="width: 7%">Nota</vs-th>
            <vs-th id="center" sort-key="id" style="width: 7%">Contrato</vs-th>
            <vs-th style="width: 15%">Cliente</vs-th>
            <vs-th style="width: 12%">Empresa</vs-th>
            <vs-th id="center" style="width: 12%">Valor Líquido</vs-th>
            <vs-th id="center" style="width: 12%">Valor Bruto</vs-th>
            <vs-th id="center" style="width: 12%">Emissão</vs-th>
            <vs-th id="center" sort-key="qtd_boletos" style="width: 10%"
            >N° Boletos
            </vs-th
            >
            <vs-th sort-key="acoes" style="width: 10%">Ações</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr v-for="(tr, index) in data" :key="index" :data="tr">

              <vs-td
                  :data="tr.id"
                  class="text-center font-semibold"
                  style="font-size: 12px"
              >{{ tr.numero }}
              </vs-td
              >
              <vs-td
                  :data="tr.id"
                  class="text-center font-semibold"
                  style="font-size: 12px"
              >{{ tr.id_contrato }}
              </vs-td
              >
              <vs-td :data="tr.cliente">
                <ModalVisualizarCliente
                    :id_cliente="tr.id_cliente"
                    :nomeCliente="tr.cliente"
                    fontSize="small"
                    textColor="dark"
                    @update="getCliente()"
                />
              </vs-td>
              <vs-td style="font-size: 10px">
                <b>{{ tr.empresa }}</b>
              </vs-td>
              <vs-td class="text-center">
                <b>{{ $currency(tr.valor_liquido) }}</b>
              </vs-td>
              <vs-td class="text-center">
                <b>{{ $currency(tr.valor_bruto) }}</b>
              </vs-td>
              <vs-td class="text-center font-semibold">{{
                  tr.data_emissao ? tr.data_emissao : "Sem Data"
                }}
              </vs-td>
              <vs-td :data="tr.qtd_boletos" class="text-center font-semibold">{{
                  tr.qtd_boletos ? tr.qtd_boletos : 0
                }}
              </vs-td>
              <vs-td>
                <vs-col vs-w="4">
                  <a
                      :href="tr.link"
                      style="cursor: pointer; text-decoration: none"
                      target="_blank"
                  >
                    <vs-button
                        color="success"
                        icon="remove_red_eye"
                        radius
                        size="small"
                        type="relief"
                    />
                  </a>
                </vs-col>
                <vs-col vs-w="4">
                  <Visualizar :nota="tr"></Visualizar>
                </vs-col>
                <vs-col vs-w="4">
                  <EnviarVia :nota="tr" @update="getBoletos"></EnviarVia>
                </vs-col>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <!-- </VuePerfectScrollbar> -->
      </div>
    </div>
    <vx-card card-background="dark" no-shadow>
      <vs-row
          class
          vs-align="flex-start"
          vs-justify="flex-start"
          vs-type="flex"
          vs-w="12"
      >
        <vs-col
            class
            vs-align="flex-start"
            vs-justify="flex-start"
            vs-type="flex"
            vs-w="1"
        >
          <vs-button
              color="#fff"
              icon="icon-arrow-left"
              icon-pack="feather"
              line-origin="left"
              size="small"
              type="line"
              @click="voltar()"
          >
            <span style="font-size: 14px">Voltar</span>
          </vs-button>
        </vs-col>
        <vs-col
            vs-align="flex-start"
            vs-justify="flex-start"
            vs-type="flex"
            vs-w="5"
        >
          <span class="ml-10 pt-3" style="color: white; font-size: 14px"
          >Boletos: {{ boletosTotal }}</span
          >
        </vs-col>
        <vs-col
            vs-align="flex-end"
            vs-justify="flex-end"
            vs-type="flex"
            vs-w="6"
        >
          <vs-col
              vs-align="flex-end"
              vs-justify="flex-end"
              vs-type="flex"
              vs-w="5"
          >
            <vs-button
                color="primary"
                icon="add"
                size="small"
                type="line"
                @click="enviarBoletosBatch()"
            >
              <b style="font-size: 14px">Enviar Boletos</b>
            </vs-button>
          </vs-col>
          <vs-col
              vs-align="flex-end"
              vs-justify="flex-end"
              vs-type="flex"
              vs-w="5"
          >
            <vs-button
                color="primary"
                icon="add"
                size="small"
                type="line"
                @click="gerarRemessa()"
            >
              <b style="font-size: 14px">Gerar Remessas</b>
            </vs-button>
          </vs-col>
        </vs-col>
      </vs-row>
    </vx-card>
  </div>
</template>
<script>
import ModalVisualizarCliente from "./../../../cliente/visualizar.vue";
import components from "@/components/default/exports.js";
import Visualizar from "./components/visualizar";
import EnviarVia from "./components/enviarVia";
import GerarRemessas from "./components/gerarRemessas";
import EnviarBoletosBatch from "./components/enviarBoletosBatch";

export default {
  data() {
    return {
      tipo_pessoa: [
        {value: 1, nome: "PESSOA FÍSICA"},
        {value: 2, nome: "PESSOA JURÍDICA"}
      ],
      filtro: {
        dataHoje: this.$formartData.dataFiltro(),
        data_emissao: this.$formartData.dataFiltro(),
        id_empresa: null,
        busca: null,
      },
      empresas: [],
      settings: {
        maxScrollbarLength: 160,
        wheelSpeed: 0.5,
        height: 1000
      },
      selected: [],
      notasBoletos: [],
      boletosTotal: 0,

    };
  },
  methods: {
    async getEmpresas() {
      try {
        this.empresas = await this.$http.get(`empresa`);
        //    this.filtro.id_empresa = this.empresas[0].id;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
        ;
      }
    },
    async getBoletos() {
      await this.$vs.loading({container: "#tabelaBoletos", scale: 0.6});
      try {
        this.notasBoletos = await this.$http.post(`getBoletos`, this.filtro);
        this.boletosTotal = this.notasBoletos[this.notasBoletos.length - 1];
        this.notasBoletos = this.notasBoletos.slice(
            0,
            this.notasBoletos.length - 1
        );
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
        ;
      } finally {
        await this.$vs.loading.close("#tabelaBoletos > .con-vs-loading");
      }
    },
    async voltar() {
      this.$router.push("/financeiro");
    },
    async ver(data) {
      this.selected[0] = [data];
    },
    // async gerarRemessa() {
    //   await this.$vs.loading({ container: "#tabelaBoletos", scale: 0.6 });
    //   try {
    //     await this.$http.post(`gerarRemessa`, this.selected);
    //   } catch (err) {
    //     const error = this.$httpErrors(err);
    //     this.$vs.notify(error);
    // if(error.code == 401) {
    //  await window.localStorage.clear();
    //  await this.$router.push("/");
    // };
    //   } finally {
    //     await this.$vs.loading.close("#tabelaBoletos > .con-vs-loading");
    //   }
    // },
    async gerarRemessa() {
      await this.$vs.loading({container: "#tabelaBoletos", scale: 0.6});
      await this.$http
          .post("gerarRemessa", this.selected)
          .then(async response => {
            if (response == null || response == "") {
              await this.$vs.notify({
                title: "Erro ao gerar Remessa",
                color: "danger"
              });
            } else if (response.fail && response.message) {
              await this.$vs.notify({
                title: response.title,
                text: response.message,
                color: "danger"
              });
            } else if (response.message == "Server Error") {
              await this.$vs.notify({
                title: "Erro: " + response.message,
                color: "danger"
              });
            } else {
              const blob = await new Blob([response], {
                type: "application/pdf"
              });
              const link = document.createElement("a");
              link.href = await URL.createObjectURL(blob);
              link.download =
                  (await this.$formartData.formatar(
                      new Date(this.filtro.data_emissao)
                  )) + "-remessa.rem";
              await link.click();
              await URL.revokeObjectURL(link.href);
            }
          })
          .catch(console.error);
      await this.$vs.loading.close("#tabelaBoletos > .con-vs-loading");
    },
    async enviarBoletosBatch() {
      await this.$vs.loading({container: "#tabelaBoletos", scale: 0.6});
      await this.$http
          .post("enviarBoletosBatch", this.selected)
          .then(async response => {

            if (response == null || response == "") {
              await this.$vs.notify({
                title: "Erro ao enviar e-mail(s)",
                color: "danger"
              });
            } else if (response.fail && response.message) {
              await this.$vs.notify({
                title: response.title,
                text: response.message,
                color: "danger"
              });
            } else if (response.message == "Server Error") {
              await this.$vs.notify({
                title: "Erro: " + response.message,
                color: "danger"
              });
            } else {
              await this.$vs.notify({
                title: "Sucesso",
                text: "Emails em Lote Enviados Com Sucesso!",
                color: "success"
              });
            }
          })
          .catch(console.error);
      await this.$vs.loading.close("#tabelaBoletos > .con-vs-loading");
    }
  },
  async mounted() {
    if (this.$route.query.cliente > 0) {
      this.filtro.id_cliente = this.$route.query.cliente;
    }
    if (this.$route.query.contrato > 0) {
      this.filtro.id_contrato = this.$route.query.contrato;
    }
    this.filtro.data_emissao = "";
    await this.getEmpresas();
    await this.getBoletos();
  },
  components: {
    ...components,
    GerarRemessas,
    EnviarBoletosBatch,
    Visualizar,
    EnviarVia,
    ModalVisualizarCliente
  }
};
</script>
<style lang="scss">
.scroll-boleto {
  height: 73vh !important;
}

.cardTable {
  transition-duration: 300ms;
  border-style: solid;
  border-radius: 4px;
  border-color: rgba(211, 211, 211, 0.493);
  border-width: 2px;

  &:hover {
    transition-duration: 555ms;
    transform: translateY(-3px);
    box-shadow: 0px 4px 25px 0px rgba(226, 226, 226, 0.25);
  }
}

thead tr th#center {
  .vs-table-text {
    justify-content: center !important;
  }
}
</style>
